module.exports = __webpack_public_path__ + "img/loginbg.796fef88.jpg";